import type { PosAdapter, PosTerminal } from '@kassa/shared';
import { SimulatorAdapter } from './simulator';

// Terminal → adapter (printer kimi: növünə görə sürücü). manual — inteqrasiya yoxdur (kassir terminalda özü yığır).
// Real bank adapterləri (ECR/SDK) və .exe agentinin yerli körpüsü bura əlavə olunur.
const cache = new Map<string, PosAdapter>();

export function adapterFor(t: PosTerminal): PosAdapter | null {
  if (t.adapter !== 'simulator') return null;
  let a = cache.get(t.id);
  if (!a) {
    a = new SimulatorAdapter(t.id, t.terminalTid);
    cache.set(t.id, a);
  }
  return a;
}
